/** @format */

export const CLEAR_TOOLTIP = 'CLEAR_TOOLTIP';
export const SET_TOOLTIP = 'SET_TOOLTIP';
